"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleAspera = void 0;
var filesize_1 = __importDefault(require("filesize"));
var react_1 = __importDefault(require("react"));
require("./ToggleAspera.scss");
var Toggle_1 = require("@app/components/controls/Toggle");
var config_1 = require("@app/shared/config");
var utils_1 = require("@app/shared/utils");
var ToggleAspera = function (props) { return (react_1.default.createElement("div", { className: "field aspera-toggle" },
    react_1.default.createElement(Toggle_1.Toggle, { checked: props.enabled, className: 'aspera', id: 'switchExample', onToggle: props.onToggle }),
    react_1.default.createElement("span", null, "Aspera Enabled"),
    react_1.default.createElement("span", { className: "icon tooltip is-tooltip-bottom", "data-tooltip": "Enables transfer of files or packages over " + filesize_1.default(utils_1.megabytesToBytes(config_1.Config.HTTP_TRANSFER_MAX_PACKAGE_SIZE)) + ". And improves speed of transfers!" },
        react_1.default.createElement("i", { className: "fas fa-info-circle" })))); };
exports.ToggleAspera = ToggleAspera;
